import React, { useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { BackButton } from "../../components/common/MainButtonComponent";
import { routes } from "../../helper/routes";
import { sectionItems } from "./assessSectionData";
import "./AssessShared.css";
import "./ManagePaper.css";

const detailFallbacks = {
  grade: "Grade I",
  subject: "Subject I",
  language: "English",
  examCategory: "Model Examination",
  author: "Author I",
  source: "Source I",
  difficulty: "Medium",
  chapter: "Chapter I",
  year: "2021",
  term: "First Term",
  createdBy: "Head Teacher",
};

const detailRows = [
  { label: "Grade", key: "grade" },
  { label: "Subject", key: "subject" },
  { label: "Language", key: "language" },
  { label: "Exam Category", key: "examCategory" },
  { label: "Author", key: "author" },
  { label: "Source", key: "source" },
  { label: "Difficulty", key: "difficulty" },
  { label: "Chapter/Module/Unit", key: "chapter" },
  { label: "Author", key: "author" },
  { label: "Year", key: "year" },
  { label: "Term/Semester", key: "term" },
  { label: "Created By", key: "createdBy" },
  { label: "Created At", key: "createdAt" },
];

export default function ManagePaperDetailPage() {
  const history = useHistory();
  const { id } = useParams();
  const paper = useMemo(
    () =>
      sectionItems.papers.find((item) => item.id === id) ||
      sectionItems.papers[0],
    [id]
  );

  const getValue = (key) => paper?.[key] || detailFallbacks[key] || "-";

  return (
    <ContentWrapper>
      <section className="manage-paper-detail">
        <div className="manage-paper-detail__top">
          <BackButton
            label=""
            onClick={() => history.push(routes.mng_ppr)}
            title="Back"
          />
        </div>

        <div className="manage-paper-detail__header">
          <span>{paper?.code}</span>
          <h1>{paper?.name}</h1>
        </div>

        <div className="manage-paper-detail__card">
          <div className="row g-3">
            {detailRows.map((row, index) => (
              <div
                className="col-12 col-md-6 col-xl-4"
                key={`${row.label}-${index}`}
              >
                <div className="manage-paper-detail__item">
                  <span>{row.label} :</span>
                  <strong>{getValue(row.key)}</strong>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </ContentWrapper>
  );
}
